import { FONT_WEIGHT, TEXT_ALIGN } from '../../foundations/typography';
import { TextVariantType } from '../text/variants';
export const navigationRowCommonStyles = (FOUNDATIONS, FONT) => ({
    container: {
        width: '100%',
        height: 'auto',
        display: 'flex',
        flex_direction: 'row',
        align_items: 'center',
        justify_content: 'space-between',
        cursor: 'pointer',
        background_color: FOUNDATIONS.color_neutral_bg_opacity_00,
        padding: FOUNDATIONS.spacing_150,
        border_radius: FOUNDATIONS.radius_comp_navigation_navigationrow_radiussize,
    },
    decorativeElementContainer: {
        display: 'flex',
        margin_right: FOUNDATIONS.spacing_150,
    },
    decorativeIcon: {
        color: FOUNDATIONS.color_comp_navigation_navigationrow_righticon_icon,
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
    },
    textSectionContainer: {
        display: 'flex',
        flex_direction: 'column',
        align_items: 'flex-start',
        gap: FOUNDATIONS.spacing_100,
        width: '100%',
        margin_right: FOUNDATIONS.spacing_250,
    },
    iconTextContainer: {
        display: 'flex',
        flex_direction: 'row',
        align_self: 'flex-start',
        gap: FOUNDATIONS.spacing_250,
    },
    text: {
        font_variant: TextVariantType.FONT_PARAGRAPH_250,
        color: FOUNDATIONS.color_neutral_font_50,
        font_weight: FONT_WEIGHT.font_bold,
        text_align: TEXT_ALIGN.left,
    },
    description: {
        font_variant: TextVariantType.FONT_PARAGRAPH_250,
        color: FOUNDATIONS.color_neutral_font_50,
        font_weight: FONT_WEIGHT.font_regular,
        text_align: TEXT_ALIGN.left,
    },
    arrowIcon: {
        color: FOUNDATIONS.color_comp_navigation_navigationrow_righticon_icon,
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
    },
    customContentContainer: {
        display: 'flex',
        flex: 1,
        margin_right: FOUNDATIONS.spacing_250,
    },
});
//# sourceMappingURL=commonStyles.js.map